<template>
  <div>
    <label class="field_label">{{ current_champ.label }}<span class="text-red" v-if="current_champ.mandatory == 1">*</span></label>
    <div>Type de fichiers acceptés : Images, PDF (Max. 2Mo)</div>
    <div v-if="current_champ.value" class="d-flex justify-space-between align-center">
      <v-chip color="dark-green" class="mb-1" v-if="current_champ.value" prepend-icon="mdi-check"><a class="text-dark-green" :href="current_champ.value" target="_blank">Fichier importé avec succès</a></v-chip>
      <v-btn variant="plain" density="compact" v-if="!change" @click="change = true">Remplacer le fichier ?</v-btn>
    </div>

    <v-file-input
      v-if="change || !current_champ.value"
      density="compact"
      accept="image/*,.pdf"
      @update:modelValue="upload_file"
      :disabled="current_champ.disabled || is_disable"
      :required="current_champ.mandatory == 1"
      :error-messages="error"
      :rules="[$formRules.userInput(current_champ)]"
    ></v-file-input>
    <v-alert v-if="error_size != ''" text="Le fichier ne doit pas dépasser 2Mo" type="error"></v-alert>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["champ", "mode", "is_disable"],
  data() {
    return {
      change: false,
      current_champ: {},
      file: {},
      error: "",
      error_size: "",
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },
  methods: {
    async upload_file(file) {
      this.error_size = "";

      if (!file || file.size > 2000000) {
        this.error_size = "Le fichier ne doit pas dépasser 2Mo";
        return;
      }
      this.error = "";
      this.current_champ.value = "";
      var data = new FormData();
      data.append("file", file, file.name);
      let res = await axios.post("/coureur/upload_document.php", data);

      if (res.data.error) {
        this.error = res.data.error;
      } else {
        this.current_champ.value = res.data.url;
        this.$emit("uploadDocument");
      }
    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped>
</style>